import { ViewerImage } from 'app/components/Viewer/types';
import _ from 'lodash';
import { useEffect } from 'react';

export type Effect = (image: ViewerImage, imageId: string, prevImage: ViewerImage) => void;

const useImagesEffect = (
  effect: Effect,
  images: ViewerImage[],
  prevImages: ViewerImage[],
  imageDeps: any[] = undefined
) => {
  useEffect(() => {
    const imagesIds = _.uniq([..._.map(images, '_id'), ..._.map(prevImages ?? [], '_id')]);
    const keyedImages = _.keyBy(images, '_id');
    const keyedPrevImages = _.keyBy(prevImages, '_id');

    const differencesMap = _.fromPairs(
      imagesIds.map((imageId) => [imageId, [keyedPrevImages?.[imageId], keyedImages?.[imageId]]])
    );

    _.forEach(differencesMap, ([prevImage, image], imageId: string) => {
      let imagesValuesToCompare: any[] = [image];
      let prevImagesValuesToCompare: any[] = [prevImage];
      if (Array.isArray(imageDeps)) {
        imagesValuesToCompare = _.at(image, imageDeps);
        prevImagesValuesToCompare = _.at(prevImage, imageDeps);
      }
      const isAnyImageDifference = imagesValuesToCompare.some(
        (value, index) => value !== prevImagesValuesToCompare?.[index]
      );
      if (isAnyImageDifference) {
        effect(image, imageId, prevImage);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [images, prevImages, imageDeps]);
};

export const rejectImageDeletionEffect =
  (fn: Effect) => (image: ViewerImage, imageId: string, prevImage: ViewerImage) =>
    image && fn(image, imageId, prevImage);

export default useImagesEffect;
